import { Inject, Injectable } from '@angular/core';
import { ERROR_CODES, MAX_PORTFOLIOS_LIMIT_TOKEN } from '@ddt-web/config';
import { ErrorObject } from '@ddt-web/error-handler';

@Injectable({
	providedIn: 'root'
})
export class MaxPortfoliosLimiterService {
	constructor(@Inject(MAX_PORTFOLIOS_LIMIT_TOKEN) private readonly maxPortfolioLimit: number) { }

	public handleMaxPortfoliosLimiter(queryParams: any, url: string): void {
		if (queryParams?.portfolios) {
			const portfolioIds = Array.isArray(queryParams.portfolios) ? queryParams.portfolios : [queryParams.portfolios];
			if (portfolioIds.length > this.maxPortfolioLimit) {
				throw new ErrorObject({ portfolioIds, limit: this.maxPortfolioLimit, url }, ERROR_CODES.MAX_PORTFOLIOS_LIMIT_ERROR);
			}
		}
	}
}
